// loader.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private loading = new BehaviorSubject<boolean>(false);
  loading$ = this.loading.asObservable();

  private message = new BehaviorSubject<string>('Loading...');
  message$ = this.message.asObservable();

  private readonly defaultMessage = 'Loading...';
  private currentMessage = this.defaultMessage;

  // Show loader with message logic
  show(message?: string) {
    const newMessage = message?.trim() || this.defaultMessage;

    if (!this.loading.value) {
      // Not visible – show with new message
      this.currentMessage = newMessage;
      this.message.next(newMessage);
      this.loading.next(true);
      return;
    }

    // Already visible
    if (this.currentMessage === newMessage) {
      return; // Same message – ignore
    }

    const isCurrentDefault = this.currentMessage === this.defaultMessage;
    const isNewDefault = newMessage === this.defaultMessage;

    if (isCurrentDefault && !isNewDefault) {
      // Upgrade default message to specific
      this.currentMessage = newMessage;
      this.message.next(newMessage);
    }

    // Otherwise: keep showing existing message
  }

  // Hide loader if message matches logic
  hide(message?: string) {
    const targetMessage = message?.trim() || this.defaultMessage;

    if (!this.loading.value) return;

    if (this.currentMessage === targetMessage) {
      // Match – hide
      this.loading.next(false);
      this.currentMessage = this.defaultMessage;
      this.message.next(this.defaultMessage);
      return;
    }

    const isCurrentDefault = this.currentMessage === this.defaultMessage;
    const isTargetDefault = targetMessage === this.defaultMessage;

    if (isCurrentDefault && isTargetDefault) {
      // Both default – hide
      this.loading.next(false);
      return;
    }

    // Different specific message – ignore
  }

  // 🔥 Use in error handlers or when force is needed
  hideForce() {
    if (this.loading.value) {
      this.loading.next(false);
      this.currentMessage = this.defaultMessage;
      this.message.next(this.defaultMessage);
    }
  }
}
